import { render, staticRenderFns } from "./OrderMallList.vue?vue&type=template&id=3434e3dd&scoped=true"
import script from "./OrderMallList.vue?vue&type=script&lang=ts"
export * from "./OrderMallList.vue?vue&type=script&lang=ts"
import style0 from "./OrderMallList.vue?vue&type=style&index=0&id=3434e3dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3434e3dd",
  null
  
)

export default component.exports